export enum NetworkShapeTypes {
  LINE = 'LINE',
  POLYGON = 'POLYGON',
  ICON = 'ICON',
}
